import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { EmbeddedAppContactSupportLink } from '../EmbeddedAppContactSupportLink';
import { Button } from '../../../../../../../../components/CiscoUi';
import styles from './index.module.css';

export type EmbeddedAppUnavailableProps = {
  embeddedAppStatus: EmbeddedAppStates;
  refetch: VoidFunction;
};

export const EmbeddedAppUnavailable = ({
  embeddedAppStatus,
  refetch,
}: EmbeddedAppUnavailableProps) => {
  const { t } = useTranslation();

  if (embeddedAppStatus !== 'UNAVAILABLE') return <></>;

  return (
    <div className={styles.root}>
      <div
        role="heading"
        aria-level={2}
        className={classNames('base-margin-bottom', styles.heading)}
      >
        {t('sessions.tabs.launchPanel.unavailable.feedback.heading')}
      </div>
      <p className={styles.message}>
        {t('sessions.tabs.launchPanel.unavailable.feedback.message')}
      </p>
      <EmbeddedAppContactSupportLink />
      <div className="base-margin-top">
        <Button onClick={refetch}>
          {t('sessions.tabs.launchPanel.unavailable.feedback.retry')}
        </Button>
      </div>
    </div>
  );
};
